<template>
    <header class="header">
        <nav class="navbar">
            <ul class="nav-content">
                <li class="nav-content-logo">
                    <a class="nav-list-link" href="/">
                        <span></span>
                    </a>
                </li>
                <li>
                    <a class="nav-list-link" href="http://www.hxboy.com/rule2">
                        <span>生态链设计规范</span>
                    </a>
                </li>
                <li>
                    <a class="nav-list-link" href="/gzh">
                        <span>微信公众号</span>
                    </a>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'Header',
    components: {
    }
}
</script>
<style lang="scss" scoped>
    .header{
        width: 100%;
        min-width: 1226px;
        height: 44px;
        background-color: rgba(51,51,51,1);
        position: sticky;
        top: 0;
        z-index: 99;
    }
    .navbar{
        width: 1226px;
        margin: 0 auto;
        padding: 0 20px;
        position: relative;
        box-sizing: border-box;
        // -webkit-font-smoothing: antialiased;
        .nav-content{
            display: flex;
            justify-content: flex-start;
            font-size: 12px;
            .nav-content-logo{
                width: 83px;
                background-image: url('../../../assets/logo.png');
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100%;
                margin-right: 30px;
            }
        }
        .nav-list-link{
            display: block;
            color: #f5f5f7;
            font-size: 12px;
            padding: 0 8px;
            height: 44px;
            line-height: 44px;
            opacity: .8;
            transition: opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
            text-decoration: none;
            white-space: nowrap;
            letter-spacing: 0.03em;
            &:hover{
                opacity: 1;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/_common/Header/index.vue